module.exports = __webpack_public_path__ + "img/download-white.03636a1f.svg";